import { render, staticRenderFns } from "./FlagItems.vue?vue&type=template&id=24074a72&scoped=true&"
import script from "./FlagItems.vue?vue&type=script&lang=js&"
export * from "./FlagItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24074a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24074a72')) {
      api.createRecord('24074a72', component.options)
    } else {
      api.reload('24074a72', component.options)
    }
    module.hot.accept("./FlagItems.vue?vue&type=template&id=24074a72&scoped=true&", function () {
      api.rerender('24074a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fimalac/components/planning/FlagItems.vue"
export default component.exports